const CHUNK_RELOAD_KEY = 'swoop:chunk-reload'

const readFlag = () => {
  try {
    return sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1'
  } catch {
    return false
  }
}

const writeFlag = () => {
  try {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1')
  } catch {}
}

export const clearChunkReloadFlag = () => {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY)
  } catch {}
}

// A deploy replaces the hashed chunks an open page still points at, so its lazy routes 404.
// Reload only once, so a chunk that is genuinely gone cannot cause a reload loop.
export const registerChunkReload = () => {
  window.addEventListener('vite:preloadError', event => {
    if (readFlag()) return
    writeFlag()
    event.preventDefault()
    window.location.reload()
  })
}
